module.exports = __webpack_public_path__ + "static/img/D4101.9b0b034b.png";